import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Row, Col, Form, setParamsFilter, ProTableOt as ProTable_ot, useProTableOt, DemoProTableOt, message, Modal, Input } from "../../ui/ot"
import { useSOP } from "../controller/sop_controller";
import { useStep } from "../controller/step_controller";
import { useTranslation } from 'react-i18next';
import FlowEngine from './FlowEngine';
import useVerifyReject from './../components/use_verify_recject'


const SOPDisplay = ({
    propsForm,
    keyPrefix = "reservation_registration_and_space_management.sop_display",
    hasValue = false,
    onFormFinish = () => { },
    onVerifyFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    self = true,
    is_edit = false,
    defaultSopDetail = {},
    sopMode = "page",
    previewContent = <></>,
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const location = useLocation();
    const navigate = useNavigate();
    const [sop_data, set_sop_data] = useState([])
    const [sop_detail, set_sop_detail] = useState(location.state ?? defaultSopDetail)
    const [current_node_data, set_current_node_data] = useState({})
    const [can_verify_option, set_can_verify_option] = useState(true)
    const [force_reload_count, set_force_reload_count] = useState(0)
    const [form] = Form.useForm();

    const handleFlowNodesChange = (nodes) => {
        if (sop_data.length !== 0) {
            if (sop_data?.find(_ => true)?.flow_nodes.length !== nodes.length) {
                set_sop_data(prevData =>
                    prevData.map(prevObject => ({
                        ...prevObject,
                        flow_nodes: nodes
                    }))
                )
            }
        }
    }
    const handleFlowNodesPositionChange = (nodes) => {
        let pre_sop_detail = sop_detail;
        let defaultValues = [];
        defaultValues = (propsForm ? propsForm : form).getFieldsValue();
        defaultValues['position'] = nodes?.position;
        pre_sop_detail['flow_edges'] = sop_detail?.['flow_edges']?.map(prevNode =>
            prevNode.id === nodes.id ? {
                ...prevNode,
                position: nodes.position
            } : { ...prevNode }
        )
        set_sop_detail(pre_sop_detail);
        (propsForm ? propsForm : form).setFieldsValue(defaultValues);
    }
    const handleFlowEdgesChange = (edges) => {
        set_sop_data(prevData =>
            prevData.map(prevObject => ({
                ...prevObject,
                flow_edges: edges
            }))
        )
    }
    const handleFlowNodesPatch = () => {
        let defaultValues = [];
        defaultValues = (propsForm ? propsForm : form).getFieldsValue();
        patchStepData([defaultValues]);
        set_force_reload_count(force_reload_count + 1)
        navigate(location.pathname, { state: sop_detail });
    }
    const handleFlowNodeSelect = (data) => {
        set_current_node_data(data?.nodes?.find(_ => true))
        if (data?.nodes?.find(_ => true)?.is_ongoing) {
            set_can_verify_option(false)
        }
        else set_can_verify_option(true)
        form.setFieldsValue(data?.nodes?.find(_ => true) || {})
    }

    const onFinish = () => {
        const values = form.getFieldsValue();
        onFormFinish({
            ...values,
            flow_nodes: (sop_data?.find(_ => true)?.flow_nodes) ? sop_data?.find(_ => true)?.flow_nodes : [],
            flow_edges: (sop_data?.find(_ => true)?.flow_edges) ? sop_data?.find(_ => true)?.flow_edges : [],
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let defaultValues = form.getFieldsValue();
        let pre_sop_detail = sop_detail;
        pre_sop_detail['flow_nodes'] = pre_sop_detail?.['flow_nodes']?.map((item) => {
            if (item?.step_id == defaultValues?.step_id) {
                return (
                    {
                        ...item,
                        ...defaultValues,
                        data: {
                            label: defaultValues?.step_name
                        }
                    }
                )
            } else {
                return (
                    {
                        ...item,
                    }
                )
            }
        })
        defaultValues['data']['label'] = defaultValues['step_name'];
        set_force_reload_count(force_reload_count + 1);
        (propsForm ? propsForm : form).setFieldsValue(defaultValues);
    }

    const onVerifyPassClick = () => {
        let pass_data = {
            ...current_node_data,
            pass: 1
        }
        patchSOPStepVerifyData([pass_data])
    }
    const onVerifyRejectClick = (values) => {
        let reject_data = {
            ...current_node_data,
            ...values,
            pass: 0
        }
        patchSOPStepVerifyData([reject_data])
    }

    const onSOPFinish = ({ axiosMode, status, values }) => {
        // navigate('../reservation_registration');
        if (status === "success") {
            message.success('確認送出')
            onVerifyFinish(values)
        }
        // getSOPDisplayData({"ongoing_sop_id": 27})
        // setModalLoading(true)
    }
    const onSOPBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }
    const onStepFinish = ({ axiosMode, status, values }) => {
        // getSOPDisplayData({"ongoing_sop_id": 27})
        // setModalLoading(true)
    }
    const onStepBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }
    const {
        SOPData,
        getSOPData,
        DisplayData,
        getSOPDisplayData,
        postSOPData,
        patchSOPData,
        deleteSOPData,
        patchSOPStepVerifyData,
    } = useSOP({
        onSOPFinish,
        onSOPBefore,
    });
    const {
        getStepData,
        postStepData,
        patchStepData,
        deleteStepData,
    } = useStep({
        onStepFinish,
        onStepBefore,
    });

    const {
        open,
        setOpen,
        VerifyRejctModal,
        VerifyRejctButton
    } = useVerifyReject();

    useEffect(() => {
        // getSOPDisplayData({"ongoing_sop_id": 27})
        handleFlowNodeSelect({
            nodes: [sop_detail?.flow_nodes?.filter(item => item?.is_ongoing)?.reverse()?.find(_ => true)],
            edges: []
        })
    }, [])

    useEffect(() => {
        set_sop_data(DisplayData?.find(_ => true) || {})
    }, [DisplayData])

    useEffect(() => {

    }, [current_node_data])


    return (
        <Row gutter={[8, 8]}>
            {sopMode === "page" && <>
                <Col span={24}>
                    {/* <div>{sop_detail?.finish ? <>{t('sop_verify_finish')}</> : <>{t('sop_verifying')}</>}</div> */}
                    <div>{sop_detail?.finish}</div>
                    <FlowEngine
                        // custom_nodes={[]}
                        // custom_edges={[]}
                        custom_nodes={sop_detail?.flow_nodes}
                        custom_edges={sop_detail?.flow_edges}
                        force_reload_count={force_reload_count}
                        // onFlowNodesChange={(nodes) => handleFlowNodesPatch(nodes)}
                        // onFlowEdgesChange={(edges) => handleFlowEdgesChange(edges)}
                        onFlowNodeSelect={(click_data) => {
                            handleFlowNodeSelect(click_data)
                        }}
                        onFlowNodePositionChange={(nodes) => {
                            handleFlowNodesPositionChange(nodes)
                        }}
                    />
                </Col>
                <Col span={24}>
                    <Row>
                        <Col span={24}>
                            <Form
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 18 }}
                                layout="horizontal"
                                form={form}
                                onValuesChange={onValuesChange}
                                onFinish={onFinish}
                                autoComplete="off"
                                force_reload_count={force_reload_count}
                            >
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24}>
                                                <Form.Item
                                                    hidden={true}
                                                    name={"sop_id"}

                                                >
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={t('step_name')}
                                                    name={"step_name"}
                                                    rules={!hasValue ? [
                                                        {
                                                            required: true,
                                                            message: "請輸入"
                                                        }
                                                    ] : []}
                                                >
                                                    <Input disabled={hasValue} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={t('step_explain')}
                                                    name={"step_explain"}
                                                    rules={!hasValue ? [
                                                        {
                                                            required: true,
                                                            message: "請輸入"
                                                        }
                                                    ] : []}
                                                >
                                                    <Input disabled={hasValue} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={t('person_in_charge')}
                                                    name={"person_in_charge"}
                                                    rules={!hasValue ? [
                                                        {
                                                            required: true,
                                                            message: "請輸入"
                                                        }
                                                    ] : []}
                                                >
                                                    <Input disabled={hasValue} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={t('step_pass')}
                                                    name={"pass"}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Col>
            </>}
            {sopMode === "action" && <>
                <VerifyRejctModal
                    propsOpen={open}
                    propsSetOpen={setOpen}
                    onFormFinish={onVerifyRejectClick}
                    keyPrefix={"hrms.sop_display"}
                    extraElement={<>
                        <Col><Button disabled={can_verify_option} onClick={() => { setOpen(true) }}>{t("verify_reject")}</Button></Col>
                        <Col><Button disabled={can_verify_option} onClick={() => { onVerifyPassClick() }}>{t("verify_pass")}</Button></Col>
                    </>}
                />
            </>}
            {sopMode === "action" && <>
                {sop_detail?.flow_nodes?.find(item => item?.reason) ? <>
                    駁回理由：{sop_detail?.flow_nodes?.find(item => item?.reason)?.reason}
                </> : <div>{sop_detail?.finish}</div>}
                {!can_verify_option && !self && <VerifyRejctButton
                    handleOnClick={() => {
                        Modal.confirm({
                            title: '審核',
                            content: <>
                                {previewContent}
                            </>,
                            okText: t("verify_pass"),
                            cancelText: t("verify_reject"),
                            closeText: '關閉',
                            onOk: () => {
                                onVerifyPassClick()
                            },
                            onCancel: () => {
                                setOpen(true)
                            },
                            onClose: () => { },
                            close: true
                        })
                    }}
                />}
            </>
            }
            {(sopMode === "page" || sopMode === "modal") && <>
                {self ? <></> :
                    <Col span={24}>
                        <Row gutter={[8, 8]} style={{ alignItems: 'center', justifyContent: 'end' }}>
                            {is_edit && <Col><Button onClick={handleFlowNodesPatch}>{t("patch_step")}</Button></Col>}
                            <Col><Button disabled={can_verify_option} onClick={() => { setOpen(true) }}>{t("verify_reject")}</Button></Col>
                            <Col><Button disabled={can_verify_option} onClick={() => { onVerifyPassClick() }}>{t("verify_pass")}</Button></Col>
                        </Row>
                    </Col>}
            </>}
        </Row >
    )
}

export default SOPDisplay;